export const environment = {
	production: false,
	baseUrl: "https://krppcms.rks-gov.net/",
	hostURL: "https://localhost:4200",
	port: 4200
};